import { render, staticRenderFns } from "./LangSwithcer.vue?vue&type=template&id=b7d53b68&"
import script from "./LangSwithcer.vue?vue&type=script&lang=js&"
export * from "./LangSwithcer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports